import React from 'react';
import SplitActionButton from '../SplitActionButton';

export const ADD_COMPANIES_AND_SAVE_LABEL = 'Save and add company logos';
export const ADD_COMPANIES_AND_SAVE_DESCRIPTION = 'Finds company names in the text';

// Calls onSave() for a plain save and onSave({ addCompanies: true }) for
// "Save and add company logos".
const SaveSplitButton = ({ isSaving, onSave }) => (
  <SplitActionButton
    label="Save"
    onClick={() => onSave()}
    isLoading={isSaving}
    loadingText="Saving"
    menuAriaLabel="More save options"
    menuItems={[
      {
        label: ADD_COMPANIES_AND_SAVE_LABEL,
        description: ADD_COMPANIES_AND_SAVE_DESCRIPTION,
        icon: <i className="bi bi-building" aria-hidden="true" style={{ fontSize: '1.25rem' }} />,
        onClick: () => onSave({ addCompanies: true })
      }
    ]}
  />
);

export default SaveSplitButton;
